import { render, staticRenderFns } from "./LandingLogo.vue?vue&type=template&id=0fd65cb0&"
import script from "./LandingLogo.vue?vue&type=script&lang=js&"
export * from "./LandingLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports